import { render, staticRenderFns } from "./RoleplayFinish.vue?vue&type=template&id=1a15b81e&scoped=true&"
import script from "./RoleplayFinish.vue?vue&type=script&lang=js&"
export * from "./RoleplayFinish.vue?vue&type=script&lang=js&"
import style0 from "./RoleplayFinish.vue?vue&type=style&index=0&id=1a15b81e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a15b81e",
  null
  
)

export default component.exports